import React from 'react';

import PropTypes from 'prop-types';
import { Button } from '@telus-uds/components-web';

import { useLocalizedStringsContext } from '../../../../../context/LocalizedStringsContext';

const ActionButtons = ({ onApplyFilters }) => {
  const localizedStrings = useLocalizedStringsContext();
  const {
    ORDERS: { buttonApply, buttonReset }
  } = localizedStrings;
  return (
    <div
      style={{
        marginTop: '2rem',
        display: 'flex',
        gap: '1rem'
      }}
    >
      <Button onPress={() => onApplyFilters()} variant={{ priority: 'high' }}>
        {buttonApply}
      </Button>
      <Button onPress={() => onApplyFilters(true)} variant={{ priority: 'low' }}>{buttonReset}</Button>
    </div>
  );
};

ActionButtons.propTypes = {
  onApplyFilters: PropTypes.func.isRequired
};

export default ActionButtons;
